import React, { useEffect, useState } from 'react';
// mui components
import { Box, Snackbar, Typography } from '@mui/material';
// components
import Text from 'components/text';
import ChangedInput from 'pages/profile/components/changed-input';
import ChangedPasswordInput from 'pages/profile/components/changed-password-input';
import ChangePreferenceInput from 'pages/profile/components/change-preferences';
// api
import api from 'utils/api';
import { useTranslation } from 'react-i18next';
// styles
import { fontStyles } from 'styles/font-styles';
import { colors } from 'styles/colors';

/** Account-holder details (name, email, password, preferences) — user scope, not per-artist. */
const AccountSection: React.FC = () => {
  const { t } = useTranslation();

  const [toastOpen, setToastOpen] = useState(false);
  const [weeklyEmailPreference, setWeeklyEmailPreference] = useState<boolean | undefined>(
    undefined
  );

  useEffect(() => {
    api.preference.account().then((res) => {
      if (res.weeklyAnalyticsEmail) {
        setWeeklyEmailPreference(res.weeklyAnalyticsEmail === 'enabled');
      }
    });
  }, []);

  const toggleWeeklyEmailPreference = () => {
    api.preference
      .updateWeeklyAnalyticsEmail({
        data: {
          weeklyAnalyticsEmail: weeklyEmailPreference ? 'disabled' : 'enabled',
        },
      })
      .then((res) => {
        if (res.weeklyAnalyticsEmail) {
          setToastOpen(true);
          setWeeklyEmailPreference(res.weeklyAnalyticsEmail === 'enabled');
        }
      })
      .catch(() => {
        alert(t('Failed to update preference'));
      });
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '842px', margin: { xs: '16px', md: '40px' } }}>
      <Typography
        sx={{
          ...fontStyles.h3,
          color: colors.text.light.title,
          marginBottom: { xs: '4px', md: '16px' },
        }}
      >
        {t('Account')}
      </Typography>

      <ChangedInput name="fullName" label={t('Full name')} />
      <ChangedInput name="email" label={t('Email')} type="email" disabledEdit={true} />
      <ChangedPasswordInput />

      <Text fontSize="24px" marginTop="20px">
        {t('Preference')}
      </Text>
      <ChangePreferenceInput
        title={t('Weekly analytics email')}
        checked={weeklyEmailPreference === undefined ? true : !!weeklyEmailPreference}
        disabled={weeklyEmailPreference === undefined}
        onChange={() => {
          toggleWeeklyEmailPreference();
          setWeeklyEmailPreference(undefined);
        }}
      />
      <Snackbar
        open={toastOpen}
        autoHideDuration={1500}
        onClose={() => setToastOpen(false)}
        message={t('Preference updated')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      />
    </Box>
  );
};

export default AccountSection;
